/* eslint react/no-danger: 0, react-hooks/exhaustive-deps: 0, jsx-a11y/anchor-is-valid: 0, react/no-array-index-key: 0, jsx-a11y/no-static-element-interactions: 0, jsx-a11y/no-noninteractive-tabindex: 0 */
import React, { useEffect, useRef, useState } from 'react';
import Observer from 'react-intersection-observer';
import content from '../../content';
import { GAfireEvent } from '../Tracking';
import 'react-app-polyfill/ie11';
import Button from '../Button';
import 'wicg-inert'
import classNames from "classnames";
import { isEs } from "../../libs/lang";

import { fireTag } from '../../libs/analytics';

const scrollIntoViewWithOffset = (selector, offset) => {
	window.scrollTo({
		behavior: 'instant',
		top:
			document.querySelector(selector).getBoundingClientRect().top -
			document.body.getBoundingClientRect().top -
			offset,
	})
}

const ReadWatch = ({item}) => {

	let ariaLabel = '';

	if (item.medium === "video" || item.medium === "audio") {
		ariaLabel = `Watch link - ${item.btn.alt}` || `${item.btn.copy.replace('min', 'minute')}`
	}
	else {
		ariaLabel = `${item.btn.copy.replace('min', 'minute')} - ${item.btn.alt}`
	}

	return (
		<button className="read-watch"
			type="button"
			tabIndex='0'
			// aria-label={item.medium === "video" && `Watch link - ${item.btn.alt}` || `${item.btn.copy.replace('min', 'minute')}`}
			aria-label={ariaLabel}
		>
			{item.btn.copy}
		</button>

	)

}

const StatItem = ({props, item, index, isRow, toggleShare, share, tileNumber, number}) => {

	let itemType = 'Read';
	let itemTarget = 'an article';

	switch (item.medium) {
		case 'audio':
			itemType = 'Listen';
			itemTarget = 'a podcast'
			break;
		case 'video':
			itemType = 'Watch';
			itemTarget = 'a video'
			break;
	}

	const ariaText = `${tileNumber}, ${itemType} link - ${item.copy}. ${item.timeAria || ''}- ${item.btn.copy.replace('min', 'minute')} - tile opens ${itemTarget} - to activate press enter`;


	// const x = `${index + 1} of ${copy.tiles.length} tiles, ${item.medium === 'article' ? 'Read' : 'Watch'} link - ${item.copy} ${(item.timeAria || '').replace('Duration: ', '')} - tile opens ${item.medium === 'article' ? 'an article' : 'a video'} - to activate press enter`

	return (
		<a key={`stats__tile-${item.attrib.toLowerCase().replaceAll(' ', '-')}`} className={`tile ${item.medium}`}
			onClick={(event) => {
				//(`isf_C17`, {label: `${item.btn.copy} ${item.copy}`});
				fireTag('C5', `${item.title.toLowerCase()} ${item.copy.toLowerCase()}`)

				if (item.medium === 'article' || item.medium === 'audio') {
					if (item.nonWF) {
						props.displayModalOverlay(event, item.btn.href);
					}
					else {
						window.open(item.btn.href)
					}
				}
				else if (item.medium === 'video') {

					if (item.video) {
						props.displayVideoOverlay(event);
					}
					else {
						window.open(item.btn.href)
					}
				}
			}}
			onKeyDown={event => {
				if (event.key === 'Enter') {
					toggleShare(!share);
					if (item.medium === 'article' || item.medium === 'audio') {
						if (item.nonWF) {
							props.displayModalOverlay(event, item.btn.href);
						}
						else {
							window.open(item.btn.href)
						}
					}
					else if (item.medium === 'video') {
						if (item.video) {
							props.displayVideoOverlay(event);
						}
						else {
							window.open(item.btn.href)
						}
					}
				}
			}}
			data-video-type={item.medium === 'article' ? null : "vimeo"}
			data-videoid={item.video ? item.video.videoID : null} // vimeo
			tabIndex='0'
			aria-label={`${ariaText}`}
			role="button"
		>
			<div className="stat-top">
				<div
					className={classNames('stat-image', item.attrib.toLowerCase().replaceAll(' ', '-'))}
					role="img"
					alt={item.alt}
					aria-label={item.alt}
				/>
			</div>


			<div className="stat-item">
				{item.title && (<h3>{item.title}</h3>)}
				<p id={`copy-${number}`} dangerouslySetInnerHTML={{__html: item.copy}}/>
			</div>

			<ReadWatch item={item}/>


			{(item.timeAria) && (
				<p className="time">
					<time dateTime={item.time}>
						<span ref={node => node && node.setAttribute('inert', '')}>{item.time}</span>
					</time>
				</p>
			)}

		</a>
	)
}

// <div className="tile empty" tabIndex="-1" ref={node => node && node.setAttribute('inert', '')}>
const StatItemEmpty = ({stat, index}) => (
	<div className="tile empty" tabIndex="-1" ref={node => node && node.setAttribute('inert', '')}>
		<div className="stat-top">
			<div className="stat-image"/>
			<p className="cta"/>
		</div>
		<div className="stat-bottom">
			<p className="header"/>
			<p className="subheader"/>
		</div>
	</div>
)


const DrawerRow = ({props, visibleTiles, row, tilesPerRow, index, notInert, noBlank, toggleShare, share, currentTileCount, totalTiles}) => (

	<>
		<div className="drawer-row closed" data-row-count={index} ref={node => node && (!notInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))}>


			{(() => {
				const elements = [];
				for (let i = 0; i < tilesPerRow; i++) {
					if (i < row.length) {
						elements.push(<StatItem
							props={props}
							item={row[i]}
							index={i + visibleTiles}
							number={'closed-' + i}
							key={i}
							isRow
							toggleShare={toggleShare}
							share={share}
							tileNumber={`${currentTileCount} of ${totalTiles} tiles`}
						/>);

						currentTileCount++;
					}
					else {
						if (!noBlank) {
							elements.push(<StatItemEmpty key={i} index={i}/>)
						}
					}
				}
				return elements;
			})()}


		</div>
	</>
)


const Headlines = props => {
	const [share, toggleShare] = useState(false);
	const [hideInert, setHideInert] = useState(false);
	const chunk = (chunkSize, array) => {
		const R = [];
		for (let i = 0; i < array.length; i += chunkSize)
			R.push(array.slice(i, i + chunkSize));
		return R;
	}

	const drawerConfigSettings = [
		{
			min: 0,
			max: 645,
			onload: 4,
			hidden: 2,
			noBlank: true,
			showButton: false
		},
		{
			// min: 570,
			// max: 767,
			min: 646,
			max: 965,
			onload: 4,
			hidden: 2,
			noBlank: false,
			showButton: false
		},
		{
			// min: 768,
			// max: 1023,
			min: 966,
			max: 1279,
			onload: 3,
			hidden: 3,
			noBlank: false,
			showButton: true
		},
		{
			// min: 1024,
			min: 1280,
			max: 1000000000,
			onload: 4,
			hidden: 4,
			noBlank: false,
			showButton: false
		}
	]

	const buttonElShow = document.getElementById('headlines_button--show');
	const buttonElHide = document.getElementById('headlines_button--hide');

	let drawerEls = document.querySelectorAll('#sustainability-headlines .drawer-row');
	let drawerElsOpen = document.querySelectorAll('#sustainability-headlines .open.drawer-row');
	let drawerElsClosed = document.querySelectorAll('#sustainability-headlines .closed.drawer-row');
	let allOpen = drawerElsClosed.length === 0;



	useEffect(() => {
		//TODO: Optimize
		drawerEls = document.querySelectorAll('#sustainability-headlines .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-headlines .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-headlines .closed.drawer-row');

		allOpen = drawerElsClosed.length === 0;


		// if row opened, remove inert
		if (drawerElsOpen.length > 0) {
			drawerElsOpen.forEach(el => {
				el.removeAttribute('inert');
			})
		}
		// Hide View More button on load
		if (!hideInert && buttonElHide) {
			buttonElHide.inert = true;
			setHideInert(true)
		}

	})

	const drawerConfig = drawerConfigSettings.find(o => (window.innerWidth >= o.min && window.innerWidth <= o.max))

	const calcShowButton = () => drawerConfig.showButton
	let showButton = calcShowButton();

	useEffect(() => {
			const handleResize = () => {showButton = calcShowButton()};

			window.addEventListener('resize', handleResize);

			return () => window.removeEventListener('resize', handleResize);
		})

	const totalTiles = content.sustainability.headlines.tiles.length;

	// Keeps track of tile count so each tile can have an aria-label of 'tile x of y'
	let currentTileCount = 1;

	const visibleTiles = drawerConfig.onload;

	const hiddenTiles = [...content.sustainability.headlines.tiles];
	hiddenTiles.splice(0, drawerConfig.onload)

	const hiddenRows = chunk(drawerConfig.hidden, hiddenTiles);
	const lastHiddenRow = hiddenRows[hiddenRows.length - 1] || [];
	const numberBlankTiles = (drawerConfig.hidden - lastHiddenRow.length === drawerConfig.hidden) ? 0 : drawerConfig.hidden - lastHiddenRow.length;



	const showHeadlinesDrawer = (e) => {


		drawerEls = document.querySelectorAll('#sustainability-headlines .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-headlines .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-headlines .closed.drawer-row');

		allOpen = drawerElsClosed.length === 0;
		const {innerText} = buttonElShow;

		//If drawer can be opened
		[...drawerEls].forEach(drawerEl => {
			drawerEl.classList.remove('closed');
			drawerEl.classList.add('open');
			drawerEl.removeAttribute('inert');
		})

		//GAfireEvent('isf_C24', {label: innerText})

		buttonElShow.inert = buttonElShow.inert !== 'true';
		buttonElHide.inert = buttonElHide.inert === 'true';

	}

	const hideHeadlinesDrawer = (e) => {
		drawerEls = document.querySelectorAll('#sustainability-headlines .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-headlines .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-headlines .closed.drawer-row');

		allOpen = drawerElsClosed.length === 0;
		const {innerText} = buttonElHide;

		//If drawer can be closed
		[...drawerEls].forEach(drawerEl => {
			drawerEl.classList.remove('open');
			drawerEl.classList.add('closed');
			drawerEl.setAttribute('inert', '');
		})

		//GAfireEvent('isf_C24', {label: innerText})
		buttonElHide.inert = buttonElHide.inert !== 'true';
		buttonElShow.inert = buttonElShow.inert === 'true';

		scrollIntoViewWithOffset("#sustainability-headlines", document.querySelector(".sticky-nav").offsetHeight);

	}

	let scrollHeadlines = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollHeadlines && document.querySelector('#sustainability-headlines').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollHeadlines = true;
				fireTag('S4');
			}
		});
	},[])


	return (
		<>
			<Observer
				tag='section'
				id="sustainability-headlines"
				threshold={0.50}
				triggerOnce
				onChange={inView => {
					if (inView) {
						//GAfireEvent('isf_S2');
						//fireTag('S4');
					}
				}}
			>
				<h2 tabIndex="-1">{content.sustainability.headlines.headline}</h2>
				<div className="stat-tiles">

					{/* Visible tiles go here. Only show the max number specified in the drawerConfig */}


					{
						(() => {
							const elements = [];
							for (let i = 0; i < visibleTiles; i++) {
								if (i < totalTiles) {

									elements.push(<StatItem
										item={content.sustainability.headlines.tiles[i]}
										props={props}
										index={i + visibleTiles}
										key={i}
										number={'open-' + i}
										toggleShare={toggleShare}
										share={share}
										tileNumber={`${currentTileCount} of ${totalTiles} tiles`}
									/>);

									currentTileCount++;
								}
								else {


									elements.push(<StatItemEmpty index={i} key={`${Math.random() * 1000}-${i}`}/>)
								}
							}
							return elements;
						})()
					}



					{
						(showButton && (
							<Button role="button" buttonID="headlines_button--show" tabIndex='0' aria-expanded="false" handleClick={async () => {
								await showHeadlinesDrawer();
								document.querySelector('#sustainability-headlines .drawer-row.open .tile').focus()
							}}
							>
								Load more opportunities
							</Button>
						))
					}

					{/* If more tiles are available for the drawer, create drawer */}
					{
						(totalTiles > visibleTiles && (
							(() => {
								const elements = [];
								hiddenRows.forEach((row, index) => {
									elements.push(
										<DrawerRow
											id="widget1"
											props={props}
											key={index}
											data-index={index}
											index={index + visibleTiles}
											row={row}
											visibleTiles={visibleTiles}
											hiddenTiles={numberBlankTiles}
											tilesPerRow={drawerConfig.hidden}
											noBlank={drawerConfig.noBlank}
											toggleShare={toggleShare}
											share={share}
											totalTiles={totalTiles}
											currentTileCount={currentTileCount}
										/>
									)
								})
								return elements;
							})()
						))
					}

					{
						(showButton && (

							<Button
								role="button"
								buttonID="headlines_button--hide"
								key=""
								tabIndex='0'
								aria-expanded="true"
								handleClick={() => {
									hideHeadlinesDrawer();
								}}
							>
								View less
							</Button>

						))
					}
				</div>
			</Observer>
		</>
	);
}

export default Headlines;
